module.exports = __webpack_public_path__ + "static/media/dp-logo-new-white.564ee0b3.png";